import {connect} from 'react-redux';

import {makeMapDispatchToProps, makeMapStateToProps} from '../../helpers/reselectHelpers';
import {SettingsAppsTabsEnum, SettingsAppsUrl} from '../../models/url/settingsUrlModel';
import {AppState} from '../../store/appState';
import {fetchAllIntegrationsAsyncAction} from '../../store/data/integrations/integrationsActions';
import {fetchIntegrationTypesAsyncAction} from '../../store/data/integrationTypes/integrationTypesActions';
import {makeGetIsIntegrationTypeEnabled} from '../../store/data/integrationTypes/integrationTypesSelectors';
import {SettingsApps} from './settingsApps';

/*
 * Props.
 */

interface SettingsAppsContainerProps {
  url: SettingsAppsUrl;
}

/*
 * Selectors.
 */

function getIntegrationIdFromUrl(_state: AppState, props: SettingsAppsContainerProps) {
  if (props.url.tabPage === SettingsAppsTabsEnum.DETAILS) {
    return props.url.appId;
  }
  return undefined;
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps()(() => ({
  isIntegrationTypeEnabled: makeGetIsIntegrationTypeEnabled(getIntegrationIdFromUrl),
}));

const mapDispatchToProps = makeMapDispatchToProps()(() => ({
  fetchIntegrationTypesAsync: fetchIntegrationTypesAsyncAction,
  fetchAllIntegrationsAsync: fetchAllIntegrationsAsyncAction,
}));

export const SettingsAppsContainer = connect(mapStateToProps, mapDispatchToProps)(SettingsApps);
